import React, { Component } from 'react';
import SelectDaysQuantityView from './SelectDaysQuantityView';
import { connect } from 'react-redux';
import * as tripActions from '../../../actions/tripActions';

class HaveDates extends Component {
  changeStep = (step, values) => {
    const { changeCurrentStep, saveTripData } = this.props;
    changeCurrentStep(step);
    saveTripData(values);
  };

  render() {
    return (
      <SelectDaysQuantityView {...this.props} changeStep={this.changeStep} state={this.state} />
    );
  }
}

function mapStateToProps(state) {
  return {
    days_quantity: state.tripReducer.tripForm.days_quantity,
    know_dates: state.tripReducer.tripForm.know_dates,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeCurrentStep: step => dispatch(tripActions.changeCurrentStep(step)),
    saveTripData: data => dispatch(tripActions.saveTripData(data)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HaveDates);
